<template>
  <v-form ref="form" v-model="formValid" lazy-validation>
    <v-container fluid>
      <h3>{{ `app.interview.diseases` | trans }}</h3>
      <v-container fluid no-padding v-for="diseases in model.groupedDiseases" v-bind:key="diseases.index">
        <h4 class="mt-3">{{ `app.interview.diseases_groups.` + diseases.index | trans }}</h4>
        <v-layout wrap>
          <v-flex xs4 v-for="disease in diseases.diseases" v-bind:key="disease.id">
            <v-checkbox
                class="diseases-and-symptoms-checkbox"
                :color="`success`"
                :label="disease.name"
                v-model="disease.enabled"
            >
            </v-checkbox>
            <v-text-field
                v-if="disease.name ==='Inne' && disease.enabled"
                required
                :disabled="!disease.enabled"
                v-model="disease.custom_name"
                :label="'app.interview.disease_name' | trans"
            >
            </v-text-field>
            <v-text-field
                class="pr-1"
                v-if="disease.enabled"
                v-model="disease.medicines"
                :label="'app.interview.medicines' | trans"
            >
            </v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
      <v-divider></v-divider>
      <h3>{{ `app.interview.symptoms` | trans }}</h3>
      <v-container fluid no-padding>
        <h4 class="mt-3">{{ `app.interview.gastrointestinal_symptoms` | trans }}</h4>
        <v-layout no-padding v-for="(symptomGroup, i) in model.withoutVitamins" v-bind:key="i">
          <v-flex xs4 v-for="symptom in symptomGroup" v-bind:key="symptom.id">
            <v-checkbox
                class="diseases-and-symptoms-checkbox"
                :color="`success`"
                :label="symptom.name"
                v-model="symptom.enabled"
            >
            </v-checkbox>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container fluid no-padding>
        <h4 class="mt-3">{{ `app.interview.vitamin_deficiency_symptoms` | trans }}</h4>
        <v-layout no-padding v-for="(symptomGroup, i) in model.lowVitamins" v-bind:key="i">
          <v-flex xs4 v-for="symptom in symptomGroup" v-bind:key="symptom.id">
            <v-checkbox
                class="diseases-and-symptoms-checkbox"
                :color="`success`"
                :label="symptom.name"
                v-model="symptom.enabled"
            >
            </v-checkbox>
          </v-flex>
        </v-layout>
      </v-container>
      <v-divider v-if="showSaveButton"></v-divider>
      <v-container fluid v-if="showSaveButton">
        <v-layout align-center justify-end>
          <v-btn @click="cancel()" :disabled="loading">{{ 'app.cancel' | trans }}</v-btn>
          <v-btn color="primary" @click="save()" :disabled="!formValid || loading" :loading="loading">
            {{ 'app.save' | trans }}
          </v-btn>
        </v-layout>
      </v-container>
    </v-container>
  </v-form>
</template>
<script>
import {trans} from "../../../app";
import {mapGetters, mapActions} from "vuex";
import {helpers} from "../../../helpers";

export default {
  props: {
    showSaveButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  async created() {
    await this.fetchDiseases();
    await this.fetchSymptoms();
    this.loadModel();
  },
  data() {
    return {
      model: {
        groupedDiseases: [],
        withoutVitamins: [],
        lowVitamins: [],
      },
      groupedDiseases: [],
      formValid: false,
      withoutVitamins: [],
      lowVitamins: [],
      loading: false,
    }
  },
  computed: {
    ...mapGetters(['patient', 'interview'])
  },
  methods: {
    ...mapActions(['updateInterview']),
    loadModel() {
      this.setModelDiseases();
      this.setModelSymptoms();
      this.$forceUpdate();
    },
    setModelDiseases() {
      this.groupedDiseases.forEach((diseases, i) => {
        this.model.groupedDiseases.push({
          index: i,
          diseases: []
        });
        diseases.forEach((disease) => {
          let interviewDiseases;
          if (Array.isArray(this.interview.diseases) === false) {
            interviewDiseases = Object.values(this.interview.diseases);
          } else {
            interviewDiseases = this.interview.diseases;
          }
          interviewDiseases = interviewDiseases.filter(interviewDisease => {
            return interviewDisease.id === disease.id;
          });
          let modelDisease = {
            name: disease.name,
            id: disease.id,
            enabled: false,
            medicines: null,
            custom_name: null,
          }
          if (interviewDiseases.length > 0) {
            modelDisease.enabled = true;
            modelDisease.medicines = interviewDiseases[0].medicine;
            if (interviewDiseases[0].hasOwnProperty('name')) {
              modelDisease.custom_name = interviewDiseases[0].name;
            }
          }
          this.model.groupedDiseases[i].diseases.push(modelDisease);
        });
      });
    },
    setModelSymptoms() {
      this.model.withoutVitamins = this.group(this.transformSymptoms(this.withoutVitamins), 3)
      this.model.lowVitamins = this.group(this.transformSymptoms(this.lowVitamins), 3);
    },
    transformSymptoms(symptoms) {
      return symptoms.map(symptom => {
        return {
          enabled: this.interview.symptoms.includes(symptom.id),
          id: symptom.id,
          name: symptom.name
        }
      });
    },
    createRequestDiseases() {
      let requestDiseases = {};
      this.model.groupedDiseases.forEach((group) => {
        group.diseases.forEach((modelDisease) => {
          if (modelDisease.enabled) {
            let requestDisease = {
              id: modelDisease.id,
              medicine: modelDisease.medicines
            }
            if (modelDisease.name === 'Inne') {
              requestDisease.name = modelDisease.custom_name;
            }
            requestDiseases[modelDisease.id] = requestDisease;
          }
        })
      });
      return requestDiseases;
    },
    createRequestSymptoms() {
      let symptoms = [];
      this.model.lowVitamins.forEach((group) => {
        symptoms = symptoms.concat(
            group.filter(symptom => symptom.enabled).map(symptom => symptom.id)
        );
      })
      this.model.withoutVitamins.forEach((group) => {
        symptoms = symptoms.concat(
            group.filter(symptom => symptom.enabled).map(symptom => symptom.id)
        );
      })
      return symptoms;
    },
    group(array, chunkSize) {
      let groups = [];
      let i, l;

      for (i = 0, l = array.length; i < l; i += chunkSize) {
        groups.push(array.slice(i, i + chunkSize));
      }
      return groups;
    },
    async fetchDiseases() {
      try {
        const response = await axios.get('/v2/diseases')
        this.groupedDiseases = response.data;
      } catch (error) {
        this.sentryCaptureException(error);
      }
    },
    async fetchSymptoms() {
      try {
        const withoutVitaminsResponse = await axios.get('/v2/symptoms/without_vitamins');
        this.withoutVitamins = withoutVitaminsResponse.data.data;
        const lowVitaminsResponse = await axios.get('/v2/symptoms/low_vitamins')
        this.lowVitamins = lowVitaminsResponse.data.data;
      } catch (error) {
        this.sentryCaptureException(error);
      }

    },
    cancel() {
      this.loadModel();
      this.$emit('canceled');
    },
    async save() {
      this.loading = true;
      if (this.$refs.form.validate() === false) {
        this.loading = false;
        this.$toast.error(trans('app.save_failed'));
        return false;
      }

      let updatedInterview = helpers.deepClone(this.interview);
      updatedInterview.diseases = this.createRequestDiseases();
      updatedInterview.symptoms = this.createRequestSymptoms();

      try {
        await this.updateInterview(updatedInterview);
      } catch (error) {
        this.loading = false;
        this.sentryCaptureException(error);
        this.$toast.error(trans('app.save_failed'));
        return false;
      }

      this.loading = false;
      this.$toast.success(trans('app.actions.saved', {name: trans('app.patients.panel.interview').toLowerCase()}));
      this.$emit('saved');
      return true;
    }
  }
}
</script>
<style scoped>
.diseases-and-symptoms-checkbox {
  padding: 0;
  margin: 0 0 -12px;
}
</style>